var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.selectRandom([
			`The outcomes for ${_vm.getHeader()} are: ${_vm.getOutcomes()}.`,
			`In the context of ${_vm.getHeader()}, the following outcomes were noted: ${_vm.getOutcomes()}.`
		]))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }